<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço da Sede'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Endereço'" :SubSessao="'Endereço'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">CEP*</label>
                            <input class="field" type="text" id="cep" placeholder="" v-model="localPJ.Cep"
                                @change="validarCep">
                            <p v-if="camposObrigatorios.erroCep" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div style="width: 8%; margin-top: 35px;">
                            <a target="_blank" class="custom-link"
                                href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não
                                sei o CEP</a>
                        </div>
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Endereço/Logradouro*</label>
                            <input class="field" type="text" :disabled="isDisabledEndereco" id="endereco"
                                v-model="localPJ.Logradouro" placeholder="" @change="salvarAlteracoesLocalmente">
                            <p v-if="camposObrigatorios.erroLogradouro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="nome">Número*</label>
                            <input class="field" type="text" id="numero" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.LogradouroNumero" placeholder="">
                            <p v-if="camposObrigatorios.erroNumero" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Complemento</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.LogradouroComplemento" id="complemento" placeholder="">
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="nome">Bairro*</label>
                            <input class="field" type="text" :disabled="isDisabledEndereco" v-model="localPJ.Bairro"
                                id="bairro" placeholder="" @change="salvarAlteracoesLocalmente">
                            <p v-if="camposObrigatorios.erroBairro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Cidade</label>
                            <input class="field" type="text" :disabled="isDisabledEndereco" v-model="localPJ.Cidade"
                                id="cidade" placeholder="" @change="salvarAlteracoesLocalmente">
                            <p v-if="camposObrigatorios.erroCidade" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">UF*</label>
                            <input class="field" type="text" :disabled="isDisabledEndereco" id="uf" v-model="localPJ.Uf"
                                placeholder="" @change="salvarAlteracoesLocalmente">
                            <p v-if="camposObrigatorios.erroUf" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">País*</label>
                            <input class="field" type="text" :disabled="isDisabledEndereco" id="pais"
                                v-model="localPJ.Pais" placeholder="" @change="salvarAlteracoesLocalmente">
                            <p v-if="camposObrigatorios.erroPais" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footerFormulario">
            <div class="buttonsAcoes">
                <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao != true">Salvar e continuar
                    depois</button>
                <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao == true">Salvar</button>
                <button class="btnBlue" v-if="!Edicao" @click="proximaEtapa">Avançar</button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import viacep from '@/api/viacep';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'

export default {
    name: 'CadastroPJ_Endereco',
    props: ['informacoesEndereco', 'Edicao'],
    components: { LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
        }),
    },
    data() {
        return {
            camposObrigatorios: {
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUf: false,
                erroPais: false
            },
            isDisabledEndereco: true,
            permitirAvancar: false,
            localPJ: this.informacoesEndereco
        }
    },
    mounted() {
        this.validarFormulario();
    },
    methods: {
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUf: false,
                erroPais: false
            };
            if (!this.localPJ.Cep) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCep = true;
                    nomeDoCampo = 'CEP';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Logradouro && this.isDisabledEndereco === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroLogradouro = true;
                    nomeDoCampo = 'Endereço/Logradouro';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.LogradouroNumero) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroNumero = true;
                    nomeDoCampo = 'Número do Endereço';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Bairro && this.isDisabledEndereco === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroBairro = true;
                    nomeDoCampo = 'Bairro';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Cidade && this.isDisabledEndereco === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCidade = true;
                    nomeDoCampo = 'Cidade';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Uf && this.isDisabledEndereco === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroUf = true;
                    nomeDoCampo = 'UF';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Pais && this.isDisabledEndereco === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroPais = true;
                    nomeDoCampo = 'País';
                }
                this.permitirAvancar = false;
            }



            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar`,
                });
            }
        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 6);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PJ_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PJ_SALVAR_INFO_ENDERECO', this.localPJ);
            this.validarFormulario();
        },
        async validarCep() {
            this.localPJ.Cep = this.localPJ.Cep.replace(/\D/g, '');
            if (this.localPJ.Cep.length != 8) {
                this.$swal({
                    icon: 'error',
                    title: 'Oops...',
                    text: `CEP informado está fora do padrão.`,
                });
                this.localPJ.Logradouro = null;
                this.localPJ.Bairro = null;
                this.localPJ.Cidade = null;
                this.localPJ.Uf = null;
                this.localPJ.Pais = null;
                this.localPJ.Cep = null;
                this.salvarAlteracoesLocalmente();
                this.isDisabledEndereco = true;
            }
            else {
                const { data } = await viacep.get(`/ws/${this.localPJ.Cep}/json/`);
                if (data.erro) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Oops...',
                        text: `CEP informado não foi localizado, preencha os campos manualmente.`,
                    });
                    this.isDisabledEndereco = false;
                } else {
                    this.erro = false;
                    this.localPJ.Logradouro = data.logradouro;
                    this.localPJ.Bairro = data.bairro;
                    this.localPJ.Cidade = data.localidade;
                    this.localPJ.Uf = data.uf;
                    this.localPJ.Pais = 'Brasil';
                    this.salvarAlteracoesLocalmente();
                    if (this.localPJ.Logradouro === '' || this.localPJ.Bairro == '') {
                        this.isDisabledEndereco = false;
                    } else {
                        this.isDisabledEndereco = true;
                    }
                }
            }
        },
    }
}

</script>
<!--
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');



.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
}

.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;
    /* Fonte Inter */

    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }

}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }

    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .fieldInRadio {
            border-radius: 8px;
            /* Raio de borda */
            border: 1px solid #D0D5DD;
            /* Borda */
            padding: 10px 14px;
            /* Preenchimento interno */
            background-color: #F9FAFB;
            /* Cor de fundo */
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }


    label {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        font-weight: 500;
        /* Peso médio */
        font-size: 14px;
        /* Tamanho da fonte */
        line-height: 20px;
        /* Altura da linha */
        color: #344054;
        /* Cor */
        display: block;
        /* Garante que a label fique acima do input */
        margin-bottom: 8px;
        /* Espaçamento entre a label e o input abaixo dela */
    }

}





.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;

    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>
-->